import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

import "../styles/layout.css";
import "../styles/sidebar.css";
import "../styles/topbar.css";
import "../styles/dashboard.css";
import "../styles/table.css";
import "../styles/forms.css";
import "../styles/modal.css";
import "../styles/utilities.css";

export default function AdminLayout() {
  const location = useLocation();

  return (
    <div className="admin-layout">
      <Sidebar />

      <div className="admin-main">
        <Topbar />

        <div className="admin-content">
          <Outlet key={location.pathname} />
        </div>
      </div>
    </div>
  );
}
